import { render, staticRenderFns } from "./ordersTrajectory.vue?vue&type=template&id=b5b356ac&scoped=true&"
import script from "./ordersTrajectory.vue?vue&type=script&lang=js&"
export * from "./ordersTrajectory.vue?vue&type=script&lang=js&"
import style0 from "./ordersTrajectory.vue?vue&type=style&index=0&id=b5b356ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b356ac",
  null
  
)

export default component.exports